import {useContext, useEffect} from 'react';
import AppContext from "../../contexts/AppContext";

const FRESHWORKS_WIDGET_ID = process.env.REACT_APP_FRESHWORKS_WIDGET_ID || 0;

const FreshWorksWidget = () => {
    const { userInfo } = useContext(AppContext);
    const { AllowedContactUS } = userInfo.Permissions;

    useEffect(() => {
        if(!AllowedContactUS) {
            return;
        }

        // Define Freshworks widget settings
        window.fwSettings = {
            'widget_id': FRESHWORKS_WIDGET_ID
        };

        // Initialize Freshworks widget
        if (typeof window.FreshworksWidget !== 'function') {
            const n = function() {
                n.q.push(arguments);
            };
            n.q = [];
            window.FreshworksWidget = n;
        }

        // Create and add custom CSS to control the iframe position
        const styleElement = document.createElement('style');
        styleElement.textContent = `
          #launcher-frame {
            left: 20px !important;
            bottom: 20px !important;
            z-index: 1000 !important;
            position: fixed !important;
          }
          
          #freshworks-frame-wrapper {
            left: 20px !important;
            bottom: 90px !important;
            z-index: 1000 !important;
            position: fixed !important;
          }
    `;
        document.head.appendChild(styleElement);

        // Create and load the script
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = `https://widget.freshworks.com/widgets/${FRESHWORKS_WIDGET_ID}.js`;
        script.async = true;
        script.defer = true;

        // Add the script to the document
        document.body.appendChild(script);

        // Create a mutation observer to watch for the iframe being added to the DOM
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.addedNodes.length) {
                    mutation.addedNodes.forEach((node) => {
                        // Check if the added node is our launcher frame
                        if (node.id === 'launcher-frame' ||
                            (node.querySelector && node.querySelector('#launcher-frame'))) {
                            // Apply additional styles if needed
                            // console.log('Freshworks launcher detected and styled');
                        }
                    });
                }
            });
        });

        // Start observing the document body for changes
        observer.observe(document.body, { childList: true, subtree: true });

        // Cleanup function
        return () => {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
            if (styleElement.parentNode) {
                styleElement.parentNode.removeChild(styleElement);
            }
            observer.disconnect();
        };
    }, []);
};

export default FreshWorksWidget;
